import React from 'react'

import { QuestionProps } from '../../../types'
import { QuestionAdditionalFields } from '../QuestionAdditionalFields'

export function MediumFormEdit(props: QuestionProps) {
  return <QuestionAdditionalFields {...props} useSampleAnswer />
}
